import API from '@services/API';
import { configs } from '../../constants/configs/configs';
import { setError, startSpinner, stopSpinner } from '../common/actionCreators';

const actions = { setError, startSpinner, stopSpinner };

export const fetchCapAlertData = async (dispatch, householdId) => {
    const url = configs.endpoints.CAP_ALERTS.processReplacements({ householdId });
    const response = await API.getData(url, dispatch, actions, false);
    if (response) {
        return response;
    } else {
        dispatch(stopSpinner());
        console.error('Cannot get add member config', configs.endpoints.CAP_ALERTS);
    }
};
